import React from 'react';
import { CardListSkeleton } from '../../common/ContentSkeletons';

export default function EventTaskAttachmentPanel({ view }) {
  const {
    eventTaskAttachmentBlockRef,
    eventTaskAttachmentInputRef,
    eventTaskAttachments,
    eventTaskAttachmentsLoading,
    eventTaskCanEdit,
    eventTaskDeletingAttachmentId,
    eventTaskUploadingAttachment,
    formatDateTimeJST,
    formatFileSize,
    handleDeleteEventTaskAttachment,
    handleDownloadEventTaskAttachment,
    handleUploadEventTaskAttachment,
  } = view;

  return (
    <>
                        <div
                          ref={eventTaskAttachmentBlockRef}
                          className="event-task-detail-modal__attachmentBlock"
                        >
                          <h4>
                            添付
                            <small>{eventTaskAttachments.length}</small>
                          </h4>
                          <div className="event-task-detail-modal__attachmentUpload">
                            <input
                              ref={eventTaskAttachmentInputRef}
                              type="file"
                              onChange={handleUploadEventTaskAttachment}
                              disabled={!eventTaskCanEdit || eventTaskUploadingAttachment}
                            />
                            {eventTaskUploadingAttachment ? <span>アップロード中...</span> : null}
                          </div>
                          {eventTaskAttachmentsLoading ? (
                            <CardListSkeleton rows={2} />
                          ) : eventTaskAttachments.length === 0 ? (
                            <p className="event-task-detail-modal__emptyText">添付ファイルはまだありません。</p>
                          ) : (
                            <ul className="event-task-detail-modal__attachmentList">
                              {eventTaskAttachments.map((attachment) => (
                                <li key={attachment.id}>
                                  <div className="event-task-detail-modal__attachmentMeta">
                                    <p>{attachment.fileName || '添付ファイル'}</p>
                                    <small>
                                      {formatFileSize(attachment.fileSize)} /{' '}
                                      {attachment.uploadedByDisplayName || '管理者'} /{' '}
                                      {attachment.createdAt
                                        ? formatDateTimeJST(attachment.createdAt)
                                        : ''}
                                    </small>
                                  </div>
                                  <div className="event-task-detail-modal__attachmentActions">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        void handleDownloadEventTaskAttachment(attachment);
                                      }}
                                    >
                                      ダウンロード
                                    </button>
                                    {eventTaskCanEdit ? (
                                      <button
                                        type="button"
                                        className="event-task-detail-modal__dependencyRemove"
                                        onClick={() => {
                                          void handleDeleteEventTaskAttachment(attachment.id);
                                        }}
                                        disabled={
                                          eventTaskDeletingAttachmentId === String(attachment.id)
                                        }
                                      >
                                        {eventTaskDeletingAttachmentId === String(attachment.id)
                                          ? '削除中...'
                                          : '削除'}
                                      </button>
                                    ) : null}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
    </>
  );
}
